import { useQuery } from '@tanstack/react-query';

import { resolverBridgeApi } from 'API/resolver-bridge-api/resolver-bridge-api';
import { resolverBridgeQueryKeys } from 'features/my-zone/support-requests/components/support-requests-modals/queries/resolver-queries-keys';
import type { SupportRequestResultsResponse } from 'features/my-zone/support-requests/components/support-requests-modals/modals/request-new-location/request-property/types';
import { transformResolverResults } from 'features/my-zone/support-requests/components/support-requests-modals/queries/utils/utils';

export const useGetResolverAlternativesQuery = (
    row_id: string | undefined,
    alt_token: string | undefined,
) => {
    return useQuery<SupportRequestResultsResponse[]>({
        queryKey: resolverBridgeQueryKeys.getAlternatives(row_id, alt_token),
        enabled: !!row_id && !!alt_token,
        queryFn: async () => {
            const { data } = await resolverBridgeApi.getAlternatives(row_id!, alt_token!);

            return transformResolverResults(data);
        },
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};
